import { styled } from "@mui/material/styles";

const StyledDashboard = styled("div")(
  ({ theme }) => `

  @media screen and (max-width: 600px) {
    padding: 0px 20px;
  }
  .main-box {
    display: flex;
    gap: 13px;
     @media (max-width: 1025px) {
    flex-direction: column;
  }
}
    

`
);


export default StyledDashboard;
